export class SalesPersonAssignModel {
    public salesPersonId: string;
    public contactIds: string[];
}
